import { render, staticRenderFns } from "./teacherInt.vue?vue&type=template&id=4157baca&scoped=true"
import script from "./teacherInt.vue?vue&type=script&lang=js"
export * from "./teacherInt.vue?vue&type=script&lang=js"
import style0 from "./teacherInt.vue?vue&type=style&index=0&id=4157baca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4157baca",
  null
  
)

export default component.exports